import React from 'react';
import { Avatar } from '../ui/Avatar';

export const TypingIndicator: React.FC = () => (
  <div className="flex items-start gap-2 px-4">
    <Avatar />
    <div className="bg-white rounded-2xl border border-black/[0.08] shadow-sm px-4 py-3 flex items-center gap-1.5">
      <span className="w-2 h-2 bg-navy rounded-full animate-bounce [animation-delay:-0.3s]" />
      <span className="w-2 h-2 bg-navy rounded-full animate-bounce [animation-delay:-0.15s]" />
      <span className="w-2 h-2 bg-navy rounded-full animate-bounce" />
    </div>
  </div>
);
